document.addEventListener('scroll', function() {
    var elements = document.querySelectorAll('.hexagon, .card, .card-wrapper, .grid__item');
    var windowHeight = window.innerHeight;
    elements.forEach(function(element) {
        var rect = element.getBoundingClientRect();

        if (rect.top >= windowHeight * 0.15 && rect.bottom <= windowHeight * 0.85) {
            element.classList.add('centered');
        } else {
            element.classList.remove('centered');
        }
    });
});